import React, { useEffect, useState, useRef } from 'react';
import { useAppContext } from '../contexts/AppContext';

import Link from '../components/Link';
import { videoJson } from '../data/Data';

const PowerForward = () => {
  const videos = [
    {
      title : 'LED Bulbs',
      img   : 'powerforward1.png',
      video : 'forward1'
    },
    {
      title : 'Insulation',
      img   : 'powerforward2.png',
      video : 'forward2'
    },
    {
      title : 'Energy Efficiency',
      img   : 'powerforward3.png',
      video : 'forward3'
    },
    {
      title : 'Watts & Lumens',
      img   : 'powerforward4.png',
      video : 'forward4'
    },
    {
      title : 'Find the right<br>fixture bulbs',
      img   : 'powerforward5.png',
      video : 'forward5'
    },
    {
      title : 'Business Rebates',
      img   : 'powerforward6.png',
      video : 'forward6'
    },
    {
      title : 'Lighting And<br>Refrigeration',
      img   : 'powerforward7.png',
      video : 'forward7'
    },
    {
      title : 'New Home Build<br>BluePrint',
      img   : 'powerforward8.png',
      video : 'forward8'
    },
    {
      title : 'Light Appearance',
      img   : 'powerforward9.png',
      video : 'forward9'
    },
    {
      title : 'Energy Star Bulbs',
      img   : 'powerforward10.png',
      video : 'forward10'
    },
    {
      title : 'Shopping For Supplies<br>To Spurce Up Your Pad',
      img   : 'powerforward11.png',
      video : 'forward11'
    },
    {
      title : 'Shopping for<br>Air Conditioner',
      img   : 'powerforward12.png',
      video : 'forward12'
    },
    {
      title : 'Peak Performers',
      img   : 'powerforward13.png',
      video : 'forward13'
    },
    {
      title : 'Small Business Video',
      img   : 'powerforward14.png',
      video : 'forward14'
    },
    {
      title : 'General Rebates',
      img   : 'powerforward15.png',
      video : 'forward15'
    },
    {
      title : 'New Build Blueprint',
      img   : 'powerforward16.png',
      video : 'forward16'
    },
    {
      title : 'Live Life Forward',
      img   : 'renew1.png',
      video : 'forward17'
    },
    {
      title : 'PSO Bill Analyzer',
      img   : 'billhelp.jpg',
      video : 'billhelp'
    }
  ]

  return (
    <div className="page-container w-full h-full bg-cover bg-center relative flex justify-center items-center">
      <div className='flex justify-start items-start flex-wrap mx-auto' style={{width:'85vw'}}>
        {videos.map((item) => (
          <Link to={'/video/' + item.video} style={{padding:"1vw"}}>
            <div className='relative flex justify-start flex-col' style={{width:'15vw'}}>
              <img src={'./assets/' + item.img} className='w-full shadow-md shadow-gray-300' />
              <span className='font-sofia uppercase text-black text-left text-titlesm leading-5 mt-1' dangerouslySetInnerHTML={{__html: item.title}} />
              <img src='./assets/play-button.svg' className='absolute shadow-md shadow-gray-300 rounded-full heartbeat-image' style={{width:'2.5vw', top:"7vw", right:'1vw'}} alt={item.title} />
            </div>
          </Link>
        ))}
      </div>
      <Link to={'/home'}>
        <img src='./assets/exit.png' className='absolute bottom-10 right-10' style={{width:'5vw'}} alt='Back Button' />
      </Link>
    </div>
  )
}

export default PowerForward